import { IRootState } from "../interfaces";

export const getWidgets = (state: IRootState) =>
  state.dashboardReducer.widgets

export const selectShowTimeTrackerWidget = (state: IRootState) =>
  state.dashboardReducer.showTimeTrackerWidget
